import { all, isEmpty, isNil, none, prop } from 'ramda';
import { isNotNilOrEmpty, isNotNil } from '@@serverHelpers/index.mjs';

export const isPTIARequired = {
  required:
    'Si vous souhaitez bénéficier de la garantie décès et PTIA , vous devez faire le choix d\'un niveau de garantie. Dans le cas contraire, veuillez modifier votre choix de garantie.'
};

export const isGuaranteeInvalRequired = {
  required:
    'Si vous souhaitez bénéficier de la garantie invalidité, vous devez faire le choix d\'un niveau de garantie. Dans le cas contraire, veuillez modifier votre choix de garantie.'
};

export const childIsRequired = (grantees, error) => ({
  validate: (value) =>
    !value ||
    (value && !isEmpty(grantees) && none((grantee) => isNil(grantee.birthDate), grantees)) ||
    error
});

export const childrenGuaranteeIsRequired = {
  required:
    'Si vous souhaitez bénéficier de l’option Hospitalisation des enfants, vous devez faire le choix d\'un niveau de garantie. Dans le cas contraire, veuillez modifier votre choix de garantie.'
};

export const isFraisGenRequired = (watchedFields) => ({
  validate: (value) =>
    !value ||
    all(isNotNilOrEmpty)(watchedFields) ||
    'Si vous souhaitez bénéficier de l’option Frais généraux, vous devez faire le choix d\'un niveau de garantie et d\'une franchise (pour chacun des risques). Dans le cas contraire, veuillez modifier votre choix de garantie.'
});

export const isRenteConjointRequired = {
  required:
    'Si vous souhaitez bénéficier d’une rente conjoint, vous devez faire le choix d’un niveau de garantie. Dans le cas contraire, veuillez modifier votre choix de garantie.'
};

export const isSpouseRequired = (spouse) => ({
  validate: (value) =>
    !value ||
    (value && !isEmpty(spouse) && isNotNil(prop('birthDate', spouse))) ||
    'Si vous souhaitez bénéficier de la garantie conjoint, vous devez saisir les informations de votre conjoint. Dans le cas contraire, veuillez modifier votre choix de garantie.'
});

export const isRenteEducationRequired = {
  required:
    'Si vous souhaitez bénéficier d’une rente éducation, vous devez faire le choix d’un niveau de garantie. Dans le cas contraire, veuillez modifier votre choix de garantie.'
};

export const isGarIncapRequired = (watchedFields) => ({
  validate: (value) =>
    !value ||
    all(isNotNilOrEmpty)(watchedFields) ||
    'Si vous souhaitez bénéficier de la garantie incapacité temporaire de travail, vous devez faire le choix d\'un niveau de garantie et d\'une franchise (pour chacun des risques). Dans le cas contraire, veuillez modifier votre choix de garantie.'
});

export const childErrorHospi =
  'Si vous souhaitez bénéficier de l’option Hospitalisation des enfants, vous devez saisir au moins un enfant. Dans le cas contraire, veuillez modifier votre choix de garantie.';

export const childErrorReduc =
  'Si vous souhaitez bénéficier d’une rente éducation, vous devez saisir au moins un enfant. Dans le cas contraire, veuillez modifier votre choix de garantie.';
